angular.module('tf.controllers')
    .value('duScrollDuration', 500)
    .value('duScrollOffset', 90)
    .controller('landingPageController', ['$scope', '$http','$document','AuthService', '$timeout',
        function ($scope,  $http, $document, authService, $timeout) {

            $scope.isScrolling=false;

            $scope.form = {};
            $scope.contactButtonText = 'Send';

            $document.on('scroll', function() {
                if($document.scrollTop()>50){
                    if(!$scope.isScrolling) {
                        $scope.scrollStyle = {'background-color': '0, 0, 0, 0.8'};
                        $scope.isScrolling=true;
                        $scope.$apply();
                    }
                }else{
                    if($scope.isScrolling) {
                        $scope.scrollStyle = {};
                        $scope.isScrolling=false;
                        $scope.$apply();
                    }
                }
            });

            $scope.contact = function(){
                $scope.disableContact = true;
                $scope.contactButtonText = 'Thank you for reaching out, we will get back to you ASAP';
                $http.post('/contact', $scope.form);
            };


            var renderRecaptcha = function(){
                var recaptchaKey = '6LcK0w8UAAAAAPUV6TX-Mc4USc96isIqsk84JcdT';
                grecaptcha.render('contact-recaptcha', {
                    'sitekey' : recaptchaKey,
                    'callback' : contactRecaptchaCallback
                });
                grecaptcha.render('subscribe-recaptcha', {
                    'sitekey' : recaptchaKey,
                    'callback' : subscribeRecaptchaCallback
                });
            };
            window.contactRecaptchaCallback = function(token){
                $scope.form['g-recaptcha-response'] = token;
                $scope.contact();
            };

            function attemptRenderRecaptcha(){
                var retries = 0;
                var maxRetries = 5;
                var interval = setInterval(function(){
                    if(window.recaptchaLoaded){
                        renderRecaptcha();
                        clearInterval(interval);
                    } else {
                        retries++;
                        if(retries >= maxRetries){
                            clearInterval(interval);
                        }
                    }
                }, 1000);
            }

            attemptRenderRecaptcha();

            $scope.isLoggedIn = authService.isAuthenticated;

        }]);
